import { PipeTransform } from '@angular/core';
var FormatAddressPipe = /** @class */ (function () {
    function FormatAddressPipe() {
    }
    FormatAddressPipe.prototype.transform = function (address) {
        var parts = [];
        var streetAndNumber = [];
        address.streetName && streetAndNumber.push(address.streetName);
        address.number && streetAndNumber.push(address.number);
        var formattedStreetAndNumber = streetAndNumber.join(', ');
        parts.push(formattedStreetAndNumber);
        address.neighborhood && parts.push(address.neighborhood);
        address.city && parts.push(address.city);
        address.postalCode && parts.push(address.postalCode);
        return parts.join(' - ');
    };
    return FormatAddressPipe;
}());
export { FormatAddressPipe };
